document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll('.meganav-slick-slider-raj');

  sliders.forEach((slider) => {
    $(slider).owlCarousel({
    //   loop: true,
      loop: false,
      margin: 16,
      nav: true,
      dots: true,
      smartSpeed: 500,
      responsive: {
        0: { items: 2 },
        640: { items: 2 },
        768: { items: 4 },
        1024: { items: 7 }
      }
    });
  });
});




document.addEventListener("DOMContentLoaded", function () {
if(document.body.classList.contains('template-collection')){

var col_filter = document.querySelector('.productgrid--sidebar h2.productgrid--sidebar-title');

col_filter.addEventListener('click',function(){

    this.parentNode.classList.toggle('filter_active')
    
})

}

});




document.addEventListener("DOMContentLoaded", function () {
  if(document.body.classList.contains('template-collection')){
  const currentUrl = window.location.href.split('#')[0].split('?')[0]; // clean URL
  const nav = document.querySelector(".nav.header-nav.new-rajnavmenu");
  const sidebar = document.querySelector(".sidebar_categoryurlsec");



  // Find all anchor tags inside nav
  const links = document.querySelectorAll(".new-rajnavmenu .mega-column a");

  links.forEach(link => {
    let linkUrl = link.href.split('#')[0].split('?')[0]; // clean comparison

    if (linkUrl === currentUrl) {
      // Found the current URL link
      const megaColumn = link.closest(".mega-column");
      if (megaColumn) {
        // Get all anchor tags inside mega-column, excluding the current one
        const otherLinks = megaColumn.querySelectorAll("a[href]");
        sidebar.innerHTML = ""; // clear first

        otherLinks.forEach(other => {
          if (other !== link) {
            // clone to preserve text + attributes
            sidebar.appendChild(other.cloneNode(true));
          }
        });
      }
    }
  });
  }
});




document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains('template-collection')) {
    const currentUrl = window.location.href.split('#')[0].split('?')[0]; // clean URL
    const nav = document.querySelector(".nav.header-nav.new-rajnavmenu");

    // ✅ Desktop sidebar container
    const sidebarDesktop = document.querySelector(".sidebar_categoryurlsec");
    // ✅ Mobile sidebar container
    const sidebarMobile = document.querySelector(".sidebar_categoryurlsec-mob");

    // Find all anchor tags inside nav
    const links = document.querySelectorAll(".new-rajnavmenu .mega-column a");

    links.forEach(link => {
      let linkUrl = link.href.split('#')[0].split('?')[0]; // clean comparison

      if (linkUrl === currentUrl) {
        // Found the current URL link
        const megaColumn = link.closest(".mega-column");
        if (megaColumn) {
          // Get all anchor tags inside mega-column, excluding the current one
          const otherLinks = megaColumn.querySelectorAll("a[href]");

          // ✅ Clear both desktop & mobile containers
          if (sidebarDesktop) sidebarDesktop.innerHTML = "";
          if (sidebarMobile) sidebarMobile.innerHTML = "";

          otherLinks.forEach(other => {
            if (other !== link) {
              // clone to preserve text + attributes
              const cloned = other.cloneNode(true);

              // ✅ Append to desktop sidebar
              if (sidebarDesktop) sidebarDesktop.appendChild(cloned.cloneNode(true));
              // ✅ Append to mobile sidebar
              if (sidebarMobile) sidebarMobile.appendChild(cloned.cloneNode(true));
            }
          });
        }
      }
    });
  }
});





 $('.product-gallery--viewer').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  arrows: true, // Ensure arrows are enabled
      prevArrow: '<button class="carousel-btn prev" data-target="tab-{{ block.id }}">&#10094;</button>',
      nextArrow: '<button class="carousel-btn next" data-target="tab-{{ block.id }}">&#10095;</button>',
  asNavFor: '.gallery-navigation--scroller',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
          arrows: true,
        
      }
    }
  ]
});
$('.gallery-navigation--scroller').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  asNavFor: '.product-gallery--viewer',
  dots: false,
  centerMode: true,
  arrows:false,
  focusOnSelect: true,
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,

        
      }
    }
  ]
});


document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("sg-image-modal");
  const header = document.querySelector(".site-header");

  if (!modal || !header) return;

  const observer = new MutationObserver(function () {
    const isHidden = modal.getAttribute("aria-hidden");

    if (isHidden === "true") {
      header.classList.remove("hideme");
    }
  });

  observer.observe(modal, {
    attributes: true,
    attributeFilter: ["aria-hidden"]
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const buyNowBtn = document.querySelector(
    '.shopify-payment-button__button'
  );
  if (buyNowBtn) {
    buyNowBtn.textContent = 'BUY NOW';
  }
});




document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.description-wrapper').forEach(wrapper => {
    const checkbox = wrapper.querySelector('input[type="checkbox"]#toggle-desc-bottom') || wrapper.querySelector('input[type="checkbox"]');
    const label = wrapper.querySelector('.read-more-label');
    const extra = wrapper.querySelector('.extra-content');
    if (!checkbox || !label || !extra) return;

    extra.style.maxHeight = checkbox.checked ? `${extra.scrollHeight}px` : '0px';
    label.textContent = checkbox.checked ? 'Read less' : 'Read more';

    const applyOpen = () => {
      extra.style.maxHeight = `${extra.scrollHeight}px`;
      label.textContent = 'Read less';
    };

    const applyClose = () => {
      extra.style.maxHeight = '0px';
      label.textContent = 'Read more';
    };

    checkbox.addEventListener('change', () => {
      if (checkbox.checked) applyOpen();
      else applyClose();
    });

    label.addEventListener('click', () => setTimeout(() => {
      if (checkbox.checked) applyOpen(); else applyClose();
    }, 0));

    if (window.ResizeObserver) {
      const ro = new ResizeObserver(() => {
        if (checkbox.checked) extra.style.maxHeight = `${extra.scrollHeight}px`;
      });
      ro.observe(extra);
    } else {
      window.addEventListener('resize', () => {
        if (checkbox.checked) extra.style.maxHeight = `${extra.scrollHeight}px`;
      });
    }
  });
});

